import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { mediaQuery, font, color } = baseVariables;

export const StyledRfpHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${toRem(24)} 0;

  .rfp-title {
    margin-bottom: 0;
    color: ${color.base10};
    font-size: ${toRem(16)};
    line-height: ${toRem(20)};
    font-weight: ${font.fontWeightMedium};
  }
`;

export const StyledRfpTray = styled.div`
  width: 100%;
  height: ${toRem(430)};
  padding: 0 ${toRem(24)} ${toRem(24)} ${toRem(24)};
  background-color: ${color.base20};
  border: ${toRem(1)} solid ${color.neutral20};
  border-radius: ${toRem(12)} ${toRem(12)} 0 0;
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  @media ${mediaQuery.md} {
    height: ${toRem(240)};
  }

  @media ${mediaQuery.lg} {
    height: ${toRem(300)};
  }

  .container {
    height: 100%;
    padding: 0;

    @media ${mediaQuery.md} {
      padding: 0 ${toRem(16)};
    }

    .rfp-properties {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 70%;

      @media ${mediaQuery.md} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 70%;
      }

      @media ${mediaQuery.lg} {
        height: 75%;
      }
    }

    .rfp-cta {
      width: 100%;
      margin: ${toRem(24)} 0;
      @media ${mediaQuery.md} {
        width: auto;
        margin: 0;
      }
    }
  }
`;
